module.exports = __webpack_public_path__ + "img/r1.fb4797e2.png";